import { AxiosError } from 'axios';

export function getApiErrorMessage(error) {
    if (error instanceof AxiosError) {
        if (error.response?.status >= 500) {
            return 'Something went wrong';
        }

        const data = error.response?.data;
        const message = data?.message ?? data?.error ?? data?.detail;
        if (typeof message === 'string') {
            return message;
        } else if (data) {
            throw data;
        }
    }

    if (error instanceof Error) {
        return error.message;
    }

    throw error;
}
